import { AxiosRequestConfig } from "axios";

import axioInstance from "@/libs/axios";
import { QuotePayload } from "@/types/quote/quote-data";

// const baseURL = "http://localhost:3000/api";
const createQuoteReference = async (
  payload: QuotePayload,
  config?: AxiosRequestConfig
) => {
  const result = await axioInstance.post(
    `/initialQuestionSet`,
    {
      data: payload,
    },
    config
  );
  return result?.data?.data;
};

export default createQuoteReference;
